// extracted by mini-css-extract-plugin
module.exports = {"container":"Logo_container__LNbD6","logo":"Logo_logo__2c-QH","text":"Logo_text__ZeJeM"};